import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import EnhancedHero from '../components/EnhancedHero';
import ClientsMarquee from '../components/ClientsMarquee';
import Reviews from '../components/Reviews';
import AIInterview3D from '../components/AIInterview3D';
import NetworkEffect from '../components/NetworkEffect';
import EvaluationEngine from '../components/EvaluationEngine';
import Manifesto from '../components/Manifesto';
import EvaluationReport from '../components/EvaluationReport';
import Features from '../components/Features';
import ROICalculator from '../components/ROICalculator';
import Pricing from '../components/Pricing';
import HomeResearchSection from '../components/HomeResearchSection';
import HomeBlogSection from '../components/HomeBlogSection';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

export default function Home() {
  useSEO({
    title: 'GreenTick AI - Hire the Right Person. In 48 Hours.',
    description: 'Stop hiring without data or blindly. Hire the right person in 48 hours with GreenTick AI. Deep interactive interviews and verified skills at 10X speed.',
    canonicalPath: '/',
  });
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <main className="home-section-bg">
        {/* Global Grid Overlay with Glow - Full Opacity */}
        <div className="absolute inset-0 bg-grid-pattern opacity-100 z-0 pointer-events-none"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(20,184,166,0.15),transparent_70%)] z-0 pointer-events-none"></div>
        
        {/* Sections - Positioned above grid */}
        <div className="relative z-10">
          <EnhancedHero />
          <ClientsMarquee />
          <Reviews />
          <AIInterview3D scrollY={scrollY} />
          <NetworkEffect />
          <EvaluationEngine />
          <Manifesto />
          <EvaluationReport />
          <Features />
          <ROICalculator />
          <HomeResearchSection />
          <HomeBlogSection />
          <Pricing />
          <FAQ />
        </div>
      </main>
      <Footer />
    </div>
  );
}
